import {
  aboutUs,
  accessibility,
  backmarketWarranty,
  blackFriday,
  boMerchant,
  buyBack,
  buyingGuides,
  ccpa,
  cookiePolicy,
  dataProtection,
  giftCards,
  giftFinder,
  help,
  hireInternal,
  insurances,
  militaryProgram,
  modelsComparison,
  referFriend,
  studentGoodDeals,
  termsBuyback,
  termsService,
} from './shared-links'
import type { FooterConfig } from './types'

export const usConfig: FooterConfig = {
  columns: [
    {
      titleKey: 'categoryAbout',
      links: [
        aboutUs,
        {
          translationKey: 'press',
          href: '/en-us/about-us#scroll=false&target=heading-2-press-kit',
        },
        {
          translationKey: 'impact',
          href: '/en-us/about-us#scroll=false&target=heading-2-our-impact-report',
        },
        accessibility,
        hireInternal,
        {
          translationKey: 'trustpilot',
          href: 'https://www.trustpilot.com/review/www.backmarket.com',
        },
      ],
      socials: [
        { name: 'instagram', href: 'https://www.instagram.com/backmarket' },
        { name: 'tiktok', href: 'https://www.tiktok.com/@backmarket' },
        {
          name: 'youtube',
          href: 'https://www.youtube.com/@backmarketusa',
        },
        {
          name: 'linkedin',
          href: 'https://www.linkedin.com/company/back-market',
        },
      ],
    },
    {
      titleKey: 'categoryHelp',
      links: [
        {
          translationKey: 'contactUs',
          href: 'https://help.backmarket.com/hc/en-us/articles/360026654654-How-do-I-contact-Back-Market-Customer-Care',
        },
        help,
        {
          translationKey: 'shipping',
          href: 'https://help.backmarket.com/hc/en-us/articles/360033250174-When-should-I-expect-my-order-to-arrive',
        },
        {
          translationKey: 'return',
          href: 'https://help.backmarket.com/hc/en-us/categories/360002106194-Returns-refunds-',
        },
      ],
    },
    {
      titleKey: 'categoryServices',
      links: [
        referFriend,
        backmarketWarranty,
        insurances,
        buyBack,
        studentGoodDeals,
        militaryProgram,
        {
          translationKey: 'becomeRefurbisher',
          href: 'https://backmarket.com/en-us/seller/home',
        },
        boMerchant,
        { translationKey: 'pro', href: 'https://pro.backmarket.com' },
        {
          translationKey: 'paymentMethods',
          href: 'https://help.backmarket.com/hc/en-us/articles/360026643854-What-payment-methods-are-accepted-on-Back-Market',
        },
      ],
    },
    {
      titleKey: 'categoryGuides',
      links: [
        giftCards,
        buyingGuides,
        modelsComparison,
        giftFinder,
        blackFriday,
      ],
    },
    {
      titleKey: 'categoryLaw',
      links: [
        termsService,
        termsBuyback,
        cookiePolicy,
        ccpa,
        dataProtection,
        {
          translationKey: 'illegalContent',
          href: 'https://help.backmarket.com/hc/en-us/requests/new?ticket_form_id=12226993197084',
        },
      ],
    },
    {
      logos: ['bcorp', 'bbb'],
    },
  ],
}
